import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { GEAR_CATEGORIES } from "./constants";
import { getRoute } from "./router";
import GlobalStyles from "./theme/GlobalStyles";
import TopBar from "./components/TopBar";
import PublicHome from "./screens/PublicHome";
import AdminLogin from "./screens/admin/AdminLogin";
import AdminPanel from "./screens/admin/AdminPanel";
import EventPage from "./screens/event/EventPage";

export default function App() {
  const [route, setRoute] = useState(getRoute);
  const [categoryItems, setCategoryItems] = useState(
    Object.fromEntries(GEAR_CATEGORIES.map(c => [c.id, c.items]))
  );
  const [adminAuthed, setAdminAuthed] = useState(
    () => sessionStorage.getItem("ap_admin") === "1"
  );

  useEffect(() => {
    const handler = () => setRoute(getRoute());
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  useEffect(() => {
    const keys = GEAR_CATEGORIES.map(c => `items_${c.id}`);
    supabase.from("settings").select("key,value").in("key", keys)
      .then(({ data }) => {
        if (!data?.length) return;
        setCategoryItems(prev => {
          const next = { ...prev };
          for (const row of data) next[row.key.replace("items_", "")] = row.value;
          return next;
        });
      });
  }, []);

  const isAdmin = route.page === "admin";

  return (
    <>
      <GlobalStyles />
      <TopBar isAdmin={isAdmin} showContribute={false} />
      <main style={{ padding: "32px 0" }}>
        {route.page === "home" && <PublicHome />}
        {route.page === "admin" && (
          adminAuthed
            ? <AdminPanel
                categoryItems={categoryItems}
                onCategoryUpdate={(id, items) => setCategoryItems(prev => ({ ...prev, [id]: items }))}
              />
            : <AdminLogin onAuth={() => setAdminAuthed(true)} />
        )}
        {route.page === "event" && (
          <EventPage eventId={route.id} categoryItems={categoryItems} />
        )}
      </main>
    </>
  );
}
